// removed by extract-text-webpack-plugin
module.exports = {"PaxImage":"_avZr9"};


//////////////////
// WEBPACK FOOTER
// ./src/components/HotelDetail/HotelRoomPreferences/HotelRoomPreference/HotelRoomPreference.scss
// module id = 936
// module chunks = 0